import React, { MutableRefObject, useCallback, useEffect, useRef } from "react";
import { useAppSelector, useAppDispatch } from '../state/hooks'
//TODO 20241210 - get these from elsewhere.
/* import {
    addTable,
    Comp,
    delTable,
    CompFieldsDictionary, copyTable, getCompReference
} from "../state/slices/diagramSlice";
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPlus, faTrash, faAngleUp, faAngleDown, faCopy, faTag} from '@fortawesome/free-solid-svg-icons'
import Cols from "./cols";
import ColorPicker from "./ColorPicker";
import CompsInput from "./CompsInput";
//import { createSelector } from "@reduxjs/toolkit";
import { copyTable, selectCurrentProject, delTable, removeCompTag, selectCurrentProjectName, selectProjects, tagComp, updateProject, upsertTable, swapComps } from "../state/slices/systemSlice";
import { newProjectBuilder, ProjectBuilder } from "../state/objects/projectBuilder";
import { Comp, CompDictionary, CompFieldsDictionary, getCompReference } from "../state/objects/comp";
import { useDrag, useDrop } from "react-dnd";
import { NIL } from "uuid";
import { localconsole } from "../App";
import DraggableComp from "./DraggableComp";


//TODO (future, not required)
//TODO - add hide/hidden box to comp to allow temp removal from diagram
//TODO - create colour picker and add to column and component to allow highlights/branding
//TODO - to reorder rows, use Grip dots, not burger


interface CompsProps {
    setActiveCompKey: (activeCompKey:string) => void,
    activeCompKey: string,
}



function Comps(props: CompsProps) {

    const currentProject = useAppSelector(state => selectCurrentProject(state));

    const items = useAppSelector(state => currentProject.components)
    //const existingComponentIds = useAppSelector(state => currentProject.existingComponentIds)


    const dispatch = useAppDispatch()

    //const lastTargetIndex = React.useRef<string | null>(null); //for dnd

    /*const [showNewRowForm, setShowNewRowForm] = useState<boolean>(false);
    const [compId, setCompId] = useState<number>(0);
    const [compName, setCompName] = useState<string>("");
    const [compDBName, setCompDBName] = useState<string>("");
    const [compAlias, setCompAlias] = useState<string>("");
    const [compDescription, setCompDescription] = useState<string>("");*/


      //TODO - consider adding newComp const and refactor into comps.ts state definition
    const newItem = (e: React.MouseEvent<HTMLButtonElement>) => {
        //e.currentTarget.classList.remove("pulse");
        let new_id = crypto.randomUUID();
        dispatch(upsertTable({
            id: new_id,
            columns: [],
            colors: {},
            tags: [],
        }))
        props.setActiveCompKey((Object.keys(items).length + 1).toString());
    }

    /*const cancelForm = () => {

        setShowNewRowForm(false);
        setCompId(0);
        setCompName("");
        setCompDBName("");
        setCompAlias("");
        setCompDescription("");
        props.setActiveComp(0);
    }*/

    /*const saveForm = () => {
        const t: Comp = {
            "id": ( compId > 0 )? compId: ((existingComponentIds.length > 0)?existingComponentIds[existingComponentIds.length - 1] + 1: 1),
            "columns": (props.active_component_id && props.active_component_id > 0 && items[props.active_component_id])? items[props.active_component_id].columns:[]
        };
        if ( compName != "" ) { t["name"] = compName }
        if ( compDBName != "" ) { t["db_name"] = compDBName }
        if ( compDescription != "" ) { t["description"] = compDescription }
        if ( compAlias != "" ) { t["alias"] = compAlias }
        dispatch(addTable(t))
        cancelForm()
        setShowNewRowForm(true);
    }*/







    /*const itemList = Object.keys(items).map((i, n) => {
            let iAmActive = props.active_component_id === comp.id;

            const activateRow = (id: number) => {
                props.setActiveComp(id);
            }
            const toggleRow = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
                //e.stopPropagation();
                if (iAmActive) {
                    setCompId(0);
                    setCompName("");
                    setCompDBName("");
                    setCompAlias("");
                    setCompDescription("");
                }

                activateRow(iAmActive?0:comp.id)
            }

            return (
                <tr key={comp.id} data-key={comp.id}
                    onClick={toggleRow}
                    className={"has-text-centered" + ((iAmActive) ? " is-selected" : "") + ((comp.columns.length > 0)?" has-text-weight-medium":"")}
                    >

                        <td><Input record={comp} field={CompFieldsDictionary.name} setRecord={(c) => dispatch(addTable(c))} activateRecord={activateRow} /></td>
                        <td><Input record={comp} field={CompFieldsDictionary.db_name} setRecord={(c) => dispatch(addTable(c))} activateRecord={activateRow} /></td>
                        <td><Input record={comp} field={CompFieldsDictionary.alias} setRecord={(c) => dispatch(addTable(c))} activateRecord={activateRow} /></td>
                        <td><Input record={comp} field={CompFieldsDictionary.description} setRecord={(c) => dispatch(addTable(c))} activateRecord={activateRow} /></td>
                        <td>


                    </td>
                </tr>
            )
    })*/







    const [, drop] = useDrop(() => ({ accept: 'component' }))

    //dnd functions end



    const itemAccordian = Object.entries(items).map(([position, comp]) => {
        //localconsole(`Rendering Draggable comps position ${position}`)
        return <DraggableComp compId={comp.id} key={comp.id} isActive={props.activeCompKey === position} compKey={position} setActive={() => props.setActiveCompKey(position)} setInactive={() => props.setActiveCompKey("")}/>
            })

    //reset the form with values when the comp is clicked to allow editing
    /*useEffect(() => {
        if (props.active_component_id > 0) {
            let item = items[props.active_component_id];
            if ( item ) {
                setCompId(item.id ?? 0);
                setCompName(item.name ?? "");
                setCompDBName(item.db_name ?? "");
                setCompAlias(item.alias ?? "");
                setCompDescription(item.description ?? "");
            }
        } else {

        }
    }, [props.active_component_id])*/











    return (
        <div className={""}>
            <div className={"block"} ref={drop}>
                {itemAccordian}
            </div>

            <div className={"has-text-centered"}>
                <button className={"button is-success is-inverted pulse is-rounded p-4"} onClick={newItem} onMouseOver={(e) => e.currentTarget.classList.remove("pulse")}
                    title={"Add Component"}
                >
                    <span className={"icon"}>
                        <FontAwesomeIcon icon={faPlus} />
                    </span>
                </button>
            </div>

        </div>
    );
}

export default Comps;
